import React from 'react'
import { FormattedMessage } from 'react-intl'

export const CsLoginFooter = () => {
  return (
    <div className="container cs-login-footer">
      <div className="row">
        <div className="col-sm-12 text-center">
          <a href="https://docs.contrastsecurity.com" target="_blank">
            <FormattedMessage id="title_help" defaultMessage="Help" />
          </a>
          <span className="separator">|</span>
          <a
            href="https://support.contrastsecurity.com/hc/en-us/requests/new?ticket_form_id=360000011243"
            target="_blank"
          >
            <FormattedMessage
              id="title_contactSupport"
              defaultMessage="Contact Support"
            />
          </a>
        </div>
      </div>
    </div>
  )
}
